/* eslint-disable unicorn/filename-case */
// TODO(eslint): fix file naming
import React, { useContext } from "react";
import { TextField, Grid } from "@mui/material";
import { COVERAGE_FORM } from "@platform/rfp-core";
import { Typography } from "@platform/design-system";

import {
  BenchmarkSection,
  CommissionSection,
  SectionTitle,
} from "../../components";
import { RFP_ACTION_TYPES } from "../../constants";
import { handleNumericFieldChange } from "../utils";
import { RfpContext } from "../../contexts/rfpContext";
import CoverageButtonWrapper from "../components/coverageButtonWrapper";
import envVariables from "../../../../projectEnvVariables";
import CommentsField from "../components/commentsField";

import { createValidationHandlers } from "./coveragesValidations";

const { UPDATE_SELECTED_COVERAGE } = RFP_ACTION_TYPES;

const {
  PLAN_TYPE,
  PLANS,
  COMMENTS,
  CONTRIBUTION_TYPE,
  CONTRIBUTION_VALUE,
  CONTRIBUTION_STRUCTURE,
  CURRENT_COMMISSION,
  ENROLLED_LIVES,
  REQUESTED_COMMISSION,
  SINGLE_PLAN,
  RATE_TYPE,
  NO_PLAN,
} = COVERAGE_FORM;

const initialValues = {
  [CONTRIBUTION_STRUCTURE]: "",
  [CONTRIBUTION_TYPE]: "",
  [CONTRIBUTION_VALUE]: "",
  [ENROLLED_LIVES]: "",
  [RATE_TYPE]: "",
  [CURRENT_COMMISSION]: "",
  [REQUESTED_COMMISSION]: "",
  [COMMENTS]: "",
};
export const initialVLADDDCoveragesDetails = {
  [PLAN_TYPE]: SINGLE_PLAN,
  [PLANS]: [
    {
      ...initialValues,
      name: SINGLE_PLAN,
    },
  ],
};

const VoluntaryLifeADD = ({
  coverage,
  nextCoverage,
  isLastCoverage,
  handleNext,
  handleBack,
  prevCoverage,
  isFirstCoverage,
}) => {
  const { setRfp } = useContext(RfpContext);

  const handleFormChange = (updatedCoverage, currentPlanKey, fieldKey) => {
    setRfp({
      type: UPDATE_SELECTED_COVERAGE,
      value: updatedCoverage,
      currentPlanKey,
      fieldKey,
    });
  };

  return (
    <>
      <VoluntaryLifeADDForm
        coverage={coverage}
        onFormChange={handleFormChange}
      />
      <CoverageButtonWrapper
        displayBackButton={!isFirstCoverage}
        displayNextButton={!isLastCoverage}
        backButtonName={prevCoverage?.name}
        nextButtonName={nextCoverage?.name}
        handleBackAction={handleBack}
        handleNextAction={handleNext}
      />
    </>
  );
};

export const VoluntaryLifeADDForm = ({ coverage, onFormChange }) => {
  const isCurrentCoverage = coverage?.isCurrentCoverage;
  const currentPlan = coverage.details[PLANS][0];
  const currentPlanErrors = currentPlan.errors || {};

  const handlePlanFormChange = ({ name, value }) => {
    const localPlan = {
      ...currentPlan,
      [name]: value,
      displayName: NO_PLAN,
    };

    if (name === CONTRIBUTION_TYPE) {
      localPlan[CONTRIBUTION_VALUE] = "";
    }

    const payload = {
      ...coverage,
      details: { ...coverage.details, [PLANS]: [localPlan] },
    };

    onFormChange(payload, 0, name);
  };

  const { handlePlanFormChangeWithValidation, handlePreviousFieldsValidation } =
    createValidationHandlers({
      currentPlan,
      coverage,
      onFormChange,
      isCurrentCoverage,
      activeTab: 0,
      planName: null,
    });

  return (
    <>
      {isCurrentCoverage && (
        <>
          <SectionTitle>Enrolled Lives</SectionTitle>
          <Grid container spacing={2} px={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                autoComplete="off"
                fullWidth
                name={ENROLLED_LIVES}
                error={!!currentPlanErrors[ENROLLED_LIVES]}
                value={currentPlan[ENROLLED_LIVES] || ""}
                onChange={(e) => {
                  handleNumericFieldChange(
                    e.target,
                    currentPlan.name,
                    handlePlanFormChange,
                  );
                }}
                onFocus={() => {
                  handlePreviousFieldsValidation(ENROLLED_LIVES);
                }}
                onBlur={(e) => {
                  handlePlanFormChangeWithValidation(e.target);
                }}
                label={
                  <Typography>
                    Number of Enrolled Members{" "}
                    <span className={"required"}>*</span>
                  </Typography>
                }
              />
              {!!currentPlanErrors && (
                <Typography variant="caption" color="danger">
                  {currentPlanErrors[ENROLLED_LIVES]}
                </Typography>
              )}
            </Grid>
          </Grid>
        </>
      )}

      <CommissionSection
        handlePlanFormChange={handlePlanFormChange}
        handlePlanFormChangeWithValidation={handlePlanFormChangeWithValidation}
        handlePreviousFieldsValidation={handlePreviousFieldsValidation}
        currentPlanErrors={currentPlanErrors}
        currentPlan={currentPlan}
        isCurrentCoverage={isCurrentCoverage}
      />

      {!isCurrentCoverage && (
        <BenchmarkSection
          handlePlanFormChange={handlePlanFormChange}
          currentPlan={currentPlan}
          link={
            envVariables.VITE_REACT_APP_VOLUNTARY_LIFE_BENCHMARKS_URL || "/"
          }
          coverageName={coverage?.name}
        />
      )}

      <CommentsField
        currentPlan={currentPlan}
        onChange={(e) => {
          handlePlanFormChange(e.target);
        }}
        handlePreviousFieldsValidation={handlePreviousFieldsValidation}
      />
    </>
  );
};

export default VoluntaryLifeADD;
